import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-b border-line bg-canvas" data-id="element-85" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-6 text-center sm:px-5" data-id="element-86" data-mp="9srxhjbss65u">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.16em] text-success" data-id="element-87" data-mp="etplicjhnuf9">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-xl border border-success/40 bg-surface p-3.5 text-left" data-id="element-88" data-mp="jqpt4rvzl58h">
          <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-success-soft" data-id="element-89" data-mp="sl49yyw60ntp">
            <ShieldCheckIcon size={19} className="text-success" data-id="element-90" data-mp="xkgw1hf7pqv8" />
          </span>
          <div data-id="element-91" data-mp="12ja7l4axv7sr">
            <h2 id="garantia" className="font-display text-sm font-extrabold uppercase leading-tight text-ink sm:text-base" data-id="element-92" data-mp="12jtezr2yqdsj">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-1 text-[0.8rem] leading-snug text-ink-muted" data-id="element-93" data-mp="25sq7n0yj0d61">
              Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si
              consideras que el sistema no es adecuado para ti, puedes
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}